// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9ea25e3f","455":"28eb79ae","977":"80ad3bd3"}[chunkId] + ".chunk.js";
};